import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=07a6f512&scoped=true"
import script from "./recommend.vue?vue&type=script&lang=ts"
export * from "./recommend.vue?vue&type=script&lang=ts"
import style0 from "./recommend.vue?vue&type=style&index=0&id=07a6f512&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a6f512",
  null
  
)

export default component.exports